module.exports = __webpack_public_path__ + "img/whatsapp.323ed53.png";